<template>
    <div v-if="show">
        <slot></slot>
    </div>
</template>
<script>
import { EventBus } from '../../event-bus.js';

export default {
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        eventName: {
            type: String
        },
        showValue: {
            type: [String, Number, Boolean, Array],
            default: true
        },
        hideValue: {
            type: [String, Number, Boolean, Array],
            default: false
        }
    },
    data() {
        return {
            show: this.visible
        }
    },
    created() {
        var $vm = this;

        EventBus.$on($vm.eventName, value => {
            if (Array.isArray($vm.showValue)) {
                if ($vm.showValue.includes(value)) {
                    $vm.show = true;
                }
            } else {
                if (value == $vm.showValue) {
                    $vm.show = true;
                }
            }


            if (Array.isArray($vm.hideValue)) {
                if ($vm.hideValue.includes(value)) {
                    $vm.show = false;
                }
            } else {
                if (value == $vm.hideValue) {
                    $vm.show = false;
                }
            }
        });
    }
}
</script>